import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getExecutorWireDetailsPath = (id: string = ':id') => urlHelper(`/executor/wire/${id}/details`);
